import useConfigs from "hooks/useConfigs";
import useTheme from "hooks/useTheme";
import Head from "next/head";
import { useRouter } from "next/router";
import React, { useMemo } from "react";
import useTranslation from "translations/useTranslation";
import GoogleTagManager from "./GoogleTagManager";
import Script from "next/script";

const ProfileHead = () => {
    const router = useRouter();
    const theme = useTheme();
    const t = useTranslation();
    const configs = useConfigs();

    const robots = useMemo(
        () => (router.pathname !== "/" ? "noindex, follow" : configs.robots),
        [router.pathname, configs.robots],
    );

    return (
        <>
            <Head>
                <title>{t("PROFILE_HEAD_TITLE")}</title>
                <meta name="description" content={t("PROFILE_META_DESCRIPTION")} />
                <meta name="robots" content={robots} />
                <meta name="viewport" content="width=device-width, maximum-scale=5" />
                <meta name="author" content="Tiendeo" />
                <meta name="theme-color" content={theme.colors.primary.primary700} />
            </Head>
            <GoogleTagManager gtmId={configs.GTM_ID} />
            <GoogleTagManager gtmId={configs.global_GTM_ID} />
            <Script
                type="text/javascript"
                src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
                data-domain-script={configs.one_trust_script_id}
                data-document-language="true"
            />
        </>
    );
};

export default ProfileHead;
